export {
  AboutUsFeature as default,
  getStaticProps,
} from '@cinch-nx/landing-feature-about-us'
